import React from "react";
import { X } from "lucide-react";
import { usePortfolio } from "../providers/PortfolioContext";
import { ItemPortfolio } from "../components/ItemPortfolio";
import { RippleButton } from "../components/RippleButton";
import { ThemeToggle } from "../components/ThemeToggle";
import { CustomCursor } from "../components/CustomCursor";

interface PortfolioScreenProps {
  onNavigate: (route: string) => void;
}

export const PortfolioScreen: React.FC<PortfolioScreenProps> = ({ onNavigate }) => {
  const { portfolios } = usePortfolio();

  return (
    <div className="min-h-screen w-full bg-bg transition-colors duration-300 relative flex flex-col">
      {/* Header with Exit Button */}
      <div className="sticky top-0 bg-bg transition-colors duration-300 z-20 flex justify-end items-center gap-2 p-4 border-b border-stroke/50">
        <ThemeToggle />
        <RippleButton
          color="bg-transparent"
          hoverColor="bg-stroke/10 dark:bg-white/10"
          padding="p-3"
          radius="rounded-full"
          onTap={() => onNavigate("/")}
        >
          <X className="w-8 h-8 text-dark" />
        </RippleButton>
      </div>

      {/* Main Portfolios List Container */}
      <div className="flex-1 w-full max-w-7xl mx-auto px-6 py-12 md:px-[20vw]">
        <div className="columns-1 sm:columns-2 gap-6 space-y-6">
          {portfolios.map((portfolio, index) => {
            return (
              <div
                key={portfolio.id}
                className="break-inside-avoid animate-[slideUp_0.6s_ease-out_both]"
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                <ItemPortfolio
                  portfolio={portfolio}
                  index={index}
                  onTap={() => onNavigate(`/detail-portfolio?id=${portfolio.id}`)}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Custom Pointer Cursor Layer */}
      <CustomCursor />
    </div>
  );
};
